(function() {
  'use strict';

  let overlay, closeBtn, bodyEl, footerEl, countEl, subtotalEl;

function init() {
  overlay = document.getElementById('cart-overlay');
  if (!overlay) return;

  bodyEl = overlay.querySelector('[data-cart-overlay-body]');
  footerEl = overlay.querySelector('[data-cart-overlay-footer]');
  countEl = overlay.querySelector('[data-cart-overlay-count]');
  subtotalEl = overlay.querySelector('[data-cart-overlay-subtotal]');
  closeBtn = overlay.querySelector('.cart-overlay__close');

  // Event delegation on the overlay handles BOTH the close button and item remove clicks.
  // Delegation is more reliable than direct binding when content gets re-rendered.
  overlay.addEventListener('click', handleOverlayClick);

  document.addEventListener('keydown', handleKeydown);

  // Intercept clicks on any cart trigger in the page
  document.addEventListener('click', handleCartIconClick, true);

  // Programmatic open
  document.addEventListener('cart:open', openOverlay);

  // Refresh when cart updates from elsewhere (e.g., product modal add-to-cart)
  document.addEventListener('cart:updated', () => {
    if (overlay.getAttribute('aria-hidden') === 'false') {
      refreshCart();
    }
  });

  neutralizeHorizonCartTrigger();
}

/**
 * Handle clicks inside the overlay via event delegation.
 * Covers: close button, remove item button.
 */
function handleOverlayClick(e) {
  // Close button (back arrow)
  if (e.target.closest('.cart-overlay__close')) {
    e.preventDefault();
    e.stopPropagation();
    closeOverlay();
    return;
  }

  // Remove item button
  const removeBtn = e.target.closest('[data-action="remove"]');
  if (removeBtn) {
    e.preventDefault();
    e.stopPropagation();
    const lineKey = removeBtn.dataset.key;
    if (lineKey) removeItem(lineKey);
    return;
  }
}

/**
 * Remove a cart line item by its key.
 */
async function removeItem(lineKey) {
  // Visual: dim the item being removed
  const itemEl = bodyEl.querySelector(`[data-line-key="${lineKey}"]`);
  if (itemEl) itemEl.style.opacity = '0.4';

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!res.ok) throw new Error('Remove failed: ' + res.status);
    const cart = await res.json();
    renderCart(cart);

    // Tell the rest of the theme the cart changed
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
  } catch (err) {
    console.error('Remove item failed:', err);
    if (itemEl) itemEl.style.opacity = '1';
    alert('Could not remove item. Please try again.');
  }
}

function neutralizeHorizonCartTrigger() {
  const triggers = document.querySelectorAll(
    '[data-testid="cart-drawer-trigger"], ' +
    'button[aria-label="Cart"]'
  );
  triggers.forEach(btn => {
    if (btn.dataset.qvNeutralized) return;
    btn.dataset.qvNeutralized = 'true';

    // Just remove the on:click attribute — don't clone the node (cloning was
    // causing reactive framework to re-render and break things).
    if (btn.hasAttribute('on:click')) {
      btn.removeAttribute('on:click');
    }
  });

  // Also disable the cart-drawer-component so even if something triggers it,
  // it can't open its panel
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && !cartDrawer.dataset.qvDisabled) {
    cartDrawer.dataset.qvDisabled = 'true';
    // Add a CSS-based override to keep it hidden
    cartDrawer.setAttribute('hidden', '');
    cartDrawer.style.display = 'none';
  }
}

  function handleCartIconClick(e) {
  // Ignore clicks inside our own cart overlay — those are handled by handleOverlayClick
  if (e.target.closest('#cart-overlay')) return;

  // Match Horizon's cart trigger button OR any link/button pointing to /cart
  const cartTrigger = e.target.closest(
    '[data-testid="cart-drawer-trigger"], ' +
    'button[aria-label="Cart"], ' +
    'button[aria-label*="cart" i], ' +
    'a[href="/cart"], ' +
    'a[href$="/cart"], ' +
    'cart-icon, ' +
    '.header-actions__cart-icon'
  );
  if (!cartTrigger) return;

  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (cartTrigger.closest('.quick-view-modal')) {
    closeProductModalIfOpen();
  }

  openOverlay();
}

  function closeProductModalIfOpen() {
    const qvModal = document.getElementById('quick-view-modal');
    if (qvModal && qvModal.getAttribute('aria-hidden') === 'false') {
      const qvClose = qvModal.querySelector('.quick-view-modal__close');
      if (qvClose) qvClose.click();
    }
  }

  async function openOverlay() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-overlay-open');
    closeBtn.focus();
    await refreshCart();
  }

  function closeOverlay() {
  if (!overlay) return;
  overlay.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-overlay-open');

  // If we're sitting on the /cart URL, navigate back to home
  if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
    window.location.href = '/';
  }
}

  function handleKeydown(e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      closeOverlay();
    }
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Cart fetch failed');
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      console.error('Failed to load cart:', err);
      bodyEl.innerHTML = `<div class="cart-overlay__empty">Could not load cart.</div>`;
      footerEl.setAttribute('hidden', '');
    }
  }

  function renderCart(cart) {
    countEl.textContent = cart.item_count || 0;

    if (!cart.items || cart.items.length === 0) {
      bodyEl.innerHTML = `<div class="cart-overlay__empty">Your cart is empty</div>`;
      footerEl.setAttribute('hidden', '');
      return;
    }

    bodyEl.innerHTML = cart.items.map(item => renderItem(item)).join('');
    footerEl.removeAttribute('hidden');
    subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
  }

  function renderItem(item) {
    const imageUrl = item.image
      ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2')
      : '';

    // Show the variant (e.g. size) only if it's a real variant, not "Default Title"
    const hasVariant = item.variant_title && item.variant_title !== 'Default Title';
    const variantHtml = hasVariant
      ? `<div class="cart-item__variant">${escapeHtml(item.variant_title)}</div>`
      : '';

    return `
      <div class="cart-item" data-line-key="${item.key}">
        <img class="cart-item__image" src="${imageUrl}" alt="" loading="lazy" />
        <div class="cart-item__details">
          <h3 class="cart-item__title">${escapeHtml(item.product_title)}</h3>
          ${variantHtml}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
        </div>
        <button class="cart-item__remove" data-action="remove" data-key="${item.key}" aria-label="Remove">×</button>
      </div>
    `;
  }
  
  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    const currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();